import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-rocket-icon',
  imports: [],
  templateUrl: './rocket-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './rocket-icon.component.scss',
})
export class RocketIconComponent {}
